import { StackFrame } from '../../../common/calls/models/StackFrame';

export class ReportKey {
  constructor(
    private readonly id: number,
    private readonly reportId: number,
    private readonly shortDescription: string,
    private readonly locationsCount: number,
    private readonly operationSummary: string | null,
    private readonly information: string[] | null,
    private readonly firstCall: StackFrame | null
  ) {}

  getId() {
    return this.id;
  }

  getReportId() {
    return this.reportId;
  }

  getShortDescription() {
    return this.shortDescription;
  }

  getLocationsCount() {
    return this.locationsCount;
  }

  getOperationSummary() {
    return this.operationSummary;
  }

  getInformation() {
    return this.information;
  }

  getFirstCall() {
    return this.firstCall;
  }
}
